import WebFont from 'webfontloader';
import styled, { css } from 'styled-components';
import { TagVariants } from './type';

WebFont.load({
  google: {
    families: ['Poppins:300,400,500,600,700'],
  },
});

const predefinedColors = {
  primary: '#0057b8',
  secondary: '#6cc8dd',
  tertiary: '#95d31c',
};

export const fontWeightMap = {
  light: '300',
  normal: '400',
  medium: '500',
  'semi-bold': '600',
  bold: '700',
};

const fontSizeMap = {
  h1: '36px',
  h2: '24px',
  h3: '20px',
  h4: '20px',
  h5: '18px',
  span: '16px',
};

const getFontWeight = (
  weight: 'light' | 'normal' | 'medium' | 'semi-bold' | 'bold' | undefined,
) => {
  return fontWeightMap[weight || 'normal'];
};

const getFontSize = (as: TagVariants | undefined) => {
  return fontSizeMap[(as || 'span') as keyof typeof fontSizeMap];
};

const getColor = (color: string | undefined) => {
  if (typeof color === 'string') {
    if (color.startsWith('#') || color.startsWith('rgba') || color.startsWith('rgb')) {
      return color;
    }
    if (predefinedColors[color as keyof typeof predefinedColors]) {
      return predefinedColors[color as keyof typeof predefinedColors];
    }
  }
  return color || 'inherit';
};

export const StyledTypography = styled.p<{
  as?: TagVariants;
  weight?: 'light' | 'normal' | 'medium' | 'semi-bold' | 'bold';
  color?: string;
  whitespace?: 'normal' | 'nowrap' | 'pre' | 'pre-line' | 'pre-wrap';
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  fontSize?: number;
}>`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  line-height: 1.2;
  margin: 0;

  ${({ as, weight, color, whitespace, align, fontSize }) => css`
    font-size: ${fontSize || getFontSize(as)}px;
    font-weight: ${getFontWeight(weight)};
    color: ${getColor(color)};
    white-space: ${whitespace || 'normal'};
    text-align: ${align || 'inherit'};
  `}
`;
